import React from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/Layout";
import { UserPlus, CreditCard, Target, Clock, Trophy, Gift } from "lucide-react";

const STEPS = [
  { icon: UserPlus, t: "1. Registrati", d: "Crea il tuo account con nome, email e un nickname univoco." },
  { icon: CreditCard, t: "2. Abbonati", d: "Attiva l'abbonamento mensile a 4,99€ per sbloccare i pronostici e la competizione." },
  { icon: Target, t: "3. Pronostica 1-X-2", d: "Per ogni partita scegli 1 (casa), X (pareggio) o 2 (ospite). Un solo esito per partita." },
  { icon: Clock, t: "4. Rispetta la scadenza", d: "I pronostici si bloccano automaticamente 15 minuti prima del calcio d'inizio, verificato lato server." },
  { icon: Trophy, t: "5. Accumula punti", d: "Ogni esito corretto vale +3 punti. Nessuna penalità per gli errori. La classifica si aggiorna da sola." },
  { icon: Gift, t: "6. Vinci i premi", d: "Ogni 30 giorni il podio vince scarpe da calcio, sneaker e kit esclusivi." },
];

export default function HowItWorks() {
  return (
    <div>
      <PageHeader overline="Guida rapida" title="Come Funziona" subtitle="Dalla registrazione al premio: ecco come partecipare alla King of Resell Football Challenge." />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid md:grid-cols-2 gap-5">
          {STEPS.map((s, i) => (
            <div key={i} className="surface p-6 flex gap-4 animate-fade-up" style={{ animationDelay: `${i * 70}ms` }}>
              <div className="grid place-items-center h-12 w-12 rounded-full bg-gold-300/10 text-gold-300 shrink-0"><s.icon size={24} /></div>
              <div>
                <h3 className="font-heading text-xl font-bold uppercase text-white">{s.t}</h3>
                <p className="text-sm text-muted-foreground mt-1">{s.d}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="surface-elevated p-6 mt-10">
          <h3 className="font-heading text-2xl font-bold uppercase text-gold-300 mb-4">Il sistema di punteggio</h3>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div className="bg-ink-900 rounded-lg p-4">
              <div className="font-semibold text-white mb-1">Inter - Milan · finale 2-1</div>
              <ul className="text-muted-foreground space-y-1">
                <li>Pronostico <b className="text-status-correct">1</b>: +3 punti</li>
                <li>Pronostico X: 0 punti</li>
                <li>Pronostico 2: 0 punti</li>
              </ul>
            </div>
            <div className="bg-ink-900 rounded-lg p-4">
              <div className="font-semibold text-white mb-1">Juventus - Napoli · finale 0-0</div>
              <ul className="text-muted-foreground space-y-1">
                <li>Pronostico <b className="text-status-correct">X</b>: +3 punti</li>
                <li>Pronostico 1: 0 punti</li>
                <li>Pronostico 2: 0 punti</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <Link to="/abbonamento" className="btn-gold text-base !py-4 !px-8">PARTECIPA ALLA CHALLENGE</Link>
        </div>
      </div>
    </div>
  );
}
